import { Box } from "@mui/material";
import DashaRow from "./tables/DashaRow";
import DashaTitle from "./tables/DashaTitle";

const BreadcrumbItem = ({
  title,
  data,
  onNavigate,
  isClickable,
  currentLevel = 0,
  timezone
}) => {
  return (
    <Box className={`ml-${(currentLevel) * 4}`}>
      <DashaTitle
        className={
          isClickable ? "hover:bg-gray-100 p-2 cursor-pointer rounded" : ""
        }
        onClick={isClickable ? onNavigate : undefined}
      >
        {title}
      </DashaTitle>

      {data && <DashaRow data={data} timezone={timezone} />}
    </Box>
  );
};

export default BreadcrumbItem;
